import * as Sentry from '@sentry/react';

// Add this button component to your app to test Sentry's error tracking
function ErrorButton() {
  return (
    <button
      onClick={() => {
        // Send a log before throwing the error
        Sentry.logger.info('User triggered test error', {
          action: 'test_error_button_click',
        });
        // Send a test metric before throwing the error
        Sentry.metrics.count('test_counter', 1);
        throw new Error('This is your first error!');
      }}
    >
      Break the world
    </button>
  );
}

const TestSentryError = () => {
  return (
    <div className="container mx-auto px-4 py-20">
      <div className="max-w-2xl mx-auto text-center">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">
          Sentry Error Test Page
        </h1>
        <p className="text-lg text-gray-600 mb-8">
          Click the button below to test Sentry error tracking, logging, and metrics.
        </p>
        <div className="bg-white rounded-lg shadow-lg p-8">
          <ErrorButton />
        </div>
      </div>
    </div>
  );
};

export default TestSentryError;
